<template>
    <div>
        <div class="c_page-title">
            <div>爆版商家入驻协议</div>
        </div>
        <div style="margin-top: 20px">
            <vue-editor v-model="lincence"></vue-editor>
        </div>
        <el-button
            style="margin-top: 20px;float: right"
            type="success"
            @click="saveLicence"
            >提交</el-button
        >
    </div>
</template>

<script>
import VueEditor from "yimo-vue-editor";
export default {
    components: {
        VueEditor
    },
    data() {
        return {
            lincence: ""
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.$http.get("/erp/AdminSetting/BaobSupplyLincence").then(res => {
                if (res.data.code == 200) {
                    this.lincence = res.data.data;
                } else {
                    this.$message.e("读取协议失败");
                }
            });
        },
        saveLicence() {
            this.$http
                .post("/erp/AdminSetting/BaobSupplyLincence", {
                    lincence: this.lincence
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.$message.success("保存成功");
                    } else {
                        this.$message.error("保存失败");
                    }
                });
        }
    }
};
</script>

<style scoped>
.yimo-vue-editor {
    height: 700px !important;
    min-height: 600px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting/BaobLicence.vue